import React, { ReactNode } from "react";

interface Props {
    children: ReactNode
    className?: string
    size?: string
}

const Title : React.FC<Props> = ({ children, className, size = "" }) => {

    const sizeStyle = (() => {
        switch(size) {
            case "1":
                return "text-xl sm:text-2xl"; // Mobile: lg, Desktop: xl
            case "2":
                return "text-2xl sm:text-4xl"; // Mobile: xl, Desktop: 2xl
            case "3":
                return "text-3xl sm:text-5xl"; // Mobile: 2xl, Desktop: 3xl
            default:
                return "";
        }
    })();

    return (
        <>
            <h1 className={`${sizeStyle} pt-4 text-center font-bold font font-pirata ${className}`}>{children}</h1>
        </>
    )
}

export default Title;